import { t, tl } from '../../i18n/t';

// Absender, die der Mandant beim Hochladen wählt oder die KI erkennt (wie die Ordner der Demo, dieselbe Liste wie auf
// dem Server). Die Werte gehen so an den Server; angezeigt werden sie mit t(sender).
export const SENDERS = [
  'Finanzamt',
  'Krankenkasse',
  'Rentenversicherung',
  'Berufsgenossenschaft',
  'Stadt / Gemeinde',
  'Bank',
  'Sonstige',
] as const;
export type Sender = (typeof SENDERS)[number];

// Ordner in der Adresse: „Stadt / Gemeinde“ → stadt-gemeinde
export const senderSlug = (s: Sender) => s.toLowerCase().replace(/[^a-z]+/g, '-');
export const senderOfSlug = (slug: string | undefined) => SENDERS.find((s) => senderSlug(s) === slug) ?? null;

// Pfade: Briefe sind ein Ordner unter „Dokumente“: /app/dokumente/<Firma>/briefe/<Absender>
export function briefePath(clientId: string, sender?: Sender): string {
  return sender ? `/app/dokumente/${clientId}/briefe/${senderSlug(sender)}` : `/app/dokumente/${clientId}/briefe`;
}
export const letterPath = (clientId: string, letterId: string) => `${briefePath(clientId)}?brief=${letterId}`;

// „1 Brief“ / „3 Briefe“ (eigene Texte statt plural(): „Brief“ und „Briefe“ sind auch Überschriften)
export const letterCount = (n: number) => (n === 1 ? t('1 Brief') : t('{n} Briefe', { n }));

// Absender, wie der Mandant ihn sieht: solange die KI ihn erkennt, noch kein Ordner (Deutsch, angezeigt mit t())
export const PENDING_SENDER = tl('Wird zugeordnet …');
export const senderText = (l: { sender: Sender; senderPending: boolean }) => (l.senderPending ? PENDING_SENDER : l.sender);
